import { IState } from '../reducers'

export const getPostList = (state: IState): any[] => state.posts.list
export const getPostCount = (state: IState): number => state.posts.count
export const getPostPageNumber = (state: IState): number => state.posts.pageNumber
export const getPostReportLink = (state: IState): string => state.posts.reportLink
export const getPostPageSize = (state: IState): number => state.posts.pageSize
export const getPostIsLoading = (state: IState): boolean => state.posts.isLoading
export const getPostErrorMsg = (state: IState): string => state.posts.errorMsg
